import { Box, styled } from '@mui/material';
import { HEADER_HEIGHT, MAX_WIDTH } from '@/lib/constants';
import Input from '@/components/Common/Input';

export const PageWrapper = styled(Box)(({ theme }) => ({
    margin: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    minHeight: `calc(100vh - ${HEADER_HEIGHT + 3}px)`,
    padding: '0 40px',
    [theme.breakpoints.down('md')]: {
        padding: '0 24px',
    },
}));
export const PageMain = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexGrow: 1,
    height: '100%',
    width: '100%',
    padding: '16px 8px',
    maxWidth: MAX_WIDTH,
});

export const HeaderContent = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    maxWidth: MAX_WIDTH,
    padding: '0 24px',
    height: '100%',
}));

export const HeaderTitleWrapper = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
});

export const HeaderButtonWrapper = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'center',
});

export const AssetsWrapper = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '100%',
});

export const AssetValueBoxWrapper = styled(Box)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
});

export const AssetValueBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '100%',
    borderLeftWidth: '2px',
    borderColor: theme.palette.backgrounds.bg4,
    borderStyle: 'solid',
    paddingLeft: '16px',
    paddingRight: '8px',
    '&:first-of-type': {
        paddingLeft: 0,
        border: 'none',
    },
}));
export const ValueContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
    width: '100%',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
        justifyContent: 'flex-start',
    },
}));

export const TableWrapper = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
});

export const FormWrapper = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '0 10px',
});

export const Form = styled('form')({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
});

export const FormRow = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '24px',
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
    },
}));

export const InputBox = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '100%',
    marginBottom: '24px',
});

export const CustomInput = styled(Input)(({ theme, inputProps }) => ({
    width: '100%',
    background: inputProps?.error ? 'transparent' : theme.palette.backgrounds.bg4,
    borderRadius: '8px',
    marginBottom: 0,
}));

export const StorageFormContainer = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    maxWidth: '950px',
    width: '100%',
});

export const StorageTableWrapper = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
});

export const MobileTable = styled(StorageTableWrapper)({});
